import React from 'react';
import {FilePond} from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import { Link } from 'react-router-dom';
import RegisterUser from '../registration/registeruser.js'
import OrgCourses from './orgcourses.js'


export default class MyOrganization extends React.Component
{
    constructor(props)
    {
        super(props);
        this.createUserClick = this.createUserClick.bind(this);
        this.userSaved = this.userSaved.bind(this);
        this.state = {
            loaded: false,
            showForm: false,
            formData: null,
            userErrorMessage: "",
            users: []
        }
    }
    componentDidMount()
    {
        this.loadUsers();
    }
    loadUsers()
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Organization",
            action: "GetUsers",
            method: "get",
            success: (result) => {
                result.success ?
                    this.setState({loaded: true, users: result.users}) :
                    this.setState({loaded: true, userErrorMessage: result.message});
            },
            error: (err) => {
                this.setState({loaded: true, userErrorMessage: "An error occurred while loading users."})
            }
        })
    }
    createUserClick(event)
    {
        event.preventDefault();
        this.setState({showForm: true});
    }
    userSaved()
    {
        this.setState({showForm: false});
        this.loadUsers();
    }
    editClick(event, userID)
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Organization",
            action: "GetUser",
            method: "post",
            body: JSON.stringify({userID: userID}),
            success: (result) => {
                this.setState({
                    loaded: true, 
                    showForm: true,
                    formData: result
                })
            },
            error: (err) => {
                this.setState({loaded: true, userErrorMessage: "An error occurred while loading user."});
            }
        })
    }
    toggleEnableClick(event, userID)
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Organization",
            action: "ToggleEnabled",
            method: "post",
            body: JSON.stringify({userID: userID}),
            success: (result) => {
                if (result.success)
                {
                    this.setState({loaded: true});
                    this.loadUsers();
                }
                else
                {
                    this.setState({loaded: true, userErrorMessage: result.message})
                }
            },
            error: (err) => {
                this.setState({loaded: true, userErrorMessage: "An error occurred while updating user."})
            }
        })   
    }
    resetPasswordClick(event, email)
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Authentication",
            action: "ResetPassword",
            debug: true,
            method: "post",
            body: JSON.stringify({email: email}),
            success: (result) => {
                this.setState({loaded: true});
            },
            error: (err) =>
            {
                this.setState({loaded: true});
            }
        })
    }
    render()
    {
        const userrows = this.state.users.map((u) => (
            <tr key={u.userID}>
                <td>{u.username}</td>
                <td>{u.email}</td>
                <td>{u.roleName}</td>
                <td style={{width: "300px"}}>
                    <a className="lmsbutton" href="/" onClick={(e) => { e.preventDefault(); this.editClick(e, u.userID)}}>Edit</a>
                    {u.enabled ? (
                        <a className="lmsbutton" href="/" onClick={(e) => { e.preventDefault(); this.toggleEnableClick(e, u.userID)}}>Disable</a>
                    ) : (
                        <a className="lmsbutton" href="/" onClick={(e) => { e.preventDefault(); this.toggleEnableClick(e, u.userID)}}>Enable</a>
                    )}
                    <a className="lmsbutton" href="/" onClick={(e) => { e.preventDefault(); this.resetPasswordClick(e, u.email)}}>Reset Password</a>
                </td>
            </tr>
        ))
        const rememberToken = localStorage.getItem("LMSToken");
        const sessionToken = sessionStorage.getItem("LMSToken");
        var token  = rememberToken ? rememberToken : sessionToken ? sessionToken : null;
        const serverconfig = {
            url: "/api/Organization",
            process: {
                url: '/BulkImportEmployees',
                method: 'post',
                headers: {
                    Authorization: "Bearer " + token
                },
                onload: response => {
                    if (response.success)
                        this.loadUsers();
                }
            }
        }
        return (
            <div className="lmsdisplayarea">
                <h3>My Organization</h3>
                {this.state.loaded ? (
                    <div>
                        <Link className="lmsbutton" to="/" onClick={this.createUserClick}>Create User</Link>
                        <br />
                        {this.state.showForm ? (
                            <RegisterUser api={this.props.api} controller="Organization" action="SaveUser" buttonText="Save" 
                                allowRoleAssignment={true} onSuccess={this.userSaved} userinfo={this.state.formData} />
                        ) : null}
                        <strong>Bulk Import:</strong>
                        <FilePond server={serverconfig} allowMultiple={false} />
                        <strong>Users</strong>
                        {this.state.users.length > 0 ? (
                            <div className="lmstablecontainer">
                                <table className="lmstable">
                                    <thead>
                                        <tr>
                                            <th>Username</th>
                                            <th>Email</th>
                                            <th>Role</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userrows}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div>No users are currently defined for your organization.</div>
                        )}
                        <OrgCourses api={this.props.api}></OrgCourses>
                    </div>
                ) : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
                
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/organization/myorganization.js